export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/9Gs1JPVVPTdtd1TgrTYEtu/Mockup_AR_relanzamiento.png'

export const previewSlides = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/h1ZeDMADLeogCGjmjQhkae/03_relationship-dimensions-dashboard.webp',
    title: 'Relationship Dimensions Dashboard',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mR6g8kf7hkDPvSf4BCdwrS/01_10-minute-synastry-scan.webp',
    title: '10-Minute Synastry Scan',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/neGWTwDZxozUEMxsXmPf7Z/02_attraction-friction-matrix.webp',
    title: 'Attraction / Friction Matrix',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fxKpYmhi52J7q1WFYYsbdn/04_conflict-loop-worksheet.webp',
    title: 'Conflict Loop Worksheet',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jhG1e5vqfxJryFqY3BtYAV/05_synastry-composite-synthesizer.webp',
    title: 'Synastry + Composite Synthesizer',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7jjZKwCVV332wEmU8S2Lp9/06_complete-relationship-toolkit.webp',
    title: 'Complete Relationship Reading Toolkit',
  },
]

export const painPoints = [
  {
    title: 'Hours of Preparation',
    description: 'Reviewing charts, placements, aspects, transits and notes before the session.',
  },
  {
    title: 'Too Much Information',
    description: 'Everything seems important, making it difficult to know where to focus.',
  },
  {
    title: 'Starting From Scratch',
    description: 'Rebuilding the structure of every reading instead of following a repeatable process.',
  },
  {
    title: 'Improvising During Sessions',
    description: 'Trying to organize interpretations while the client is already waiting for answers.',
  },
]

export const solutionSteps = [
  'Client books',
  'Open Astrologer Ready',
  'Follow the framework',
  'Identify what matters',
  'Prepare the reading',
  'Deliver with confidence',
]

export const volumes = [
  {
    title: 'The Client Reading System',
    description: 'From booking and intake to preparation, session structure and follow-up.',
  },
  {
    title: 'The Natal Chart Interpretation System',
    description: 'Turn complex natal charts into clear, structured client interpretations.',
  },
  {
    title: 'The Client Question Interpretation Library',
    description: 'Know where to look when clients ask about love, money, confidence, communication, growth and more.',
  },
  {
    title: 'Transits, Timing & Forecasting System',
    description: 'Prioritize transits, organize timing and build professional forecasting readings.',
  },
  {
    title: 'The Relationship Reading System',
    description: 'A complete framework for synastry, compatibility, composite charts and relationship readings.',
  },
  {
    title: 'Career, Purpose & Life Direction',
    description: 'Structure professional readings around talents, vocation, career transitions and direction.',
  },
]

export const volumeFlow = ['Prepare', 'Interpret', 'Answer', 'Forecast', 'Relationships', 'Direction']

export const bonuses = [
  {
    title: 'The Astrology Emergency Reference Vault',
    description: 'Quick-reference answers when you need them during a session.',
  },
  {
    title: 'The Client Report & Deliverable Builder',
    description: 'Create organized professional summaries and client deliverables faster.',
  },
  {
    title: 'The Client Communication & Sensitive Reading Script Vault',
    description: 'Ready-to-use language for difficult questions and sensitive client situations.',
  },
  {
    title: 'The Professional Astrologer Business Kit',
    description: 'Systems for services, bookings, boundaries, follow-ups and rebookings.',
  },
  {
    title: 'The Visual Astrology Client Toolkit',
    description: '50+ visual charts, maps, diagrams and client-friendly tools.',
  },
]

export const withoutSystem = [
  'Search through notes',
  'Analyze everything',
  'Wonder what matters',
  'Build the session from scratch',
  'Improvise explanations',
  'Spend hours preparing',
]

export const withSystem = [
  'Open the relevant system',
  'Follow the workflow',
  'Identify priority signals',
  'Organize the interpretation',
  'Use client-friendly frameworks',
  'Enter the session prepared',
]

export const differences = [
  {
    title: 'Done-for-You Frameworks',
    description: 'Systems designed to be followed, not simply read.',
  },
  {
    title: 'Built for Client Work',
    description: 'Tools created around real consultation workflows.',
  },
  {
    title: 'Know What to Prioritize',
    description: 'Reduce information overload and focus on what matters.',
  },
  {
    title: 'Use It Again and Again',
    description: 'A repeatable professional system for future client readings.',
  },
]

export const valueStack = [
  '6 Complete Core Volumes',
  '5 Premium Bonuses',
  'Professional Frameworks',
  'Checklists & Worksheets',
  'Interpretation Systems',
  'Client Scripts',
  'Dashboards & Visual Tools',
  'Reading Structures',
  'Report & Deliverable Systems',
]

export const audience = [
  'You’re a professional astrologer or astrology reader',
  'You already understand astrology but need more structure',
  'You work with clients or want to start offering readings',
  'Your preparation takes too long',
  'You sometimes struggle to decide what matters most',
  'You want more organized and professional consultations',
  'You want reusable systems instead of starting over every time',
]

export const faqs = [
  {
    question: 'Is this for beginners?',
    answer: 'It is primarily designed for astrologers and readers who already understand astrology and want a structured professional system for client work.',
  },
  {
    question: 'Is this astrology training?',
    answer: 'Not primarily. It is a practical working system of frameworks, workflows, reference tools and client-ready resources.',
  },
  {
    question: 'What do I receive?',
    answer: '6 complete core volumes plus 5 premium bonuses in digital format.',
  },
  {
    question: 'Can I use it for real client readings?',
    answer: 'Yes. The system is specifically structured around professional preparation and consultation workflows.',
  },
  {
    question: 'Is it editable?',
    answer: 'No. The resources are delivered as ready-to-use digital materials.',
  },
  {
    question: 'How do I access it?',
    answer: 'Immediately after purchase.',
  },
  {
    question: 'Is this a subscription?',
    answer: 'No. It is a single one-time payment with lifetime access.',
  },
]
